import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-components-translations', [
  'statusChip',
  'notOfferedChip',
  'toolbarPill',
  'coursePill',
  'coursePopover',
  'coursePopoverFraction',
  'coursePopoverLanguageRow',
  'coursePopoverViewCoverage',
  'unitPill',
  'unitPopover',
  'unitPopoverTranslate',
  'panel',
  'panelRow',
  'retryButton',
  'retranslateButton',
  'retryLoadButton',
  'editButton',
  'viewButton',
]);
